import {Component, Input, OnInit} from '@angular/core';
import {Categories} from "../../../models/categories";
import {Router} from "@angular/router";
import {environment} from "../../../../../environments/environment";
import {GoogleAnalyticsService} from "../../../services/google-analytics.service";

@Component({
    selector: 'app-category-block',
    templateUrl: './category-block.component.html',
    styleUrls: ['./category-block.component.css']
})
export class CategoryBlockComponent implements OnInit {

    @Input() cat: Categories;
    @Input() catDet: Categories[];
    baseImageURL = environment.baseCatalogUrl + '/pub/media/catalog/category/';
    CategoriesDet: any = [];

    constructor(private router: Router,
                private googleService: GoogleAnalyticsService
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };
    }

    getImageURL() {
        return this.baseImageURL + '/' + this.cat.custom_attributes[0].value;
    }

    // getCategoriesDet(id) {
    //   this.CategoriesDet = [];
    //   this.CategoriesDet = this.catDet.filter( v => id === v.parent_id);
    // }

    goToCategoriesPage(id) {

       //
        // this.googleService.eventEmitter("category_view", 'ecommerce', 'category_view', this.cat.name + id);

        if (this.cat.children === "") {

            this.router.navigate(['/web/home/product/browser', id]);
        } else {
            this.router.navigate(['/web/home/categories', id]);
        }
    }

    ngOnInit(): void {


    }

}
